import { useNode } from '@craftjs/core';
import { TitlePanel, LayoutPanel, ValidationPanel, LogicPanel } from 'src/features/generalForms/builder/layout/panels';
import { FileFieldPanel } from 'src/features/generalForms/builder/layout/panels/fileFieldPanel';
import { FormFileInputComponent } from 'src/features/generalForms/builder/types/FileInput';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';
import { AppAttachmentsField } from 'src/features/generalForms/uikit/fields/attachmentsField/attachmentsField.component';

export const FormFileInput: FormFileInputComponent = (props) => {
  const {
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const validationResult = useDataKeyValidation();

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles}>
      <AppAttachmentsField
        fileTypes={props.fileTypes}
        addFileButtonText={props.addFileButtonText ?? ''}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        disabled={props.disabled}
        readOnly={true}
        maxFileSizeMb={props.maxFileSizeMb}
        multiple={props.isMultiple}
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormFileInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <FileFieldPanel />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormFileInput.craft = {
  displayName: 'File',
  rules: { canDrag: () => true },
  related: { settings: FormFileInputSettings },
};
